import { useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";

export function useChildren() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const reload = useCallback(async () => {
    setLoading(true); setError("");
    try {
      const { data } = await api.get("/circulo/children");
      setItems(data);
    } catch (e) { setError(formatApiError(e)); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  return { items, loading, error, reload };
}

export function useChild(childId) {
  const [child, setChild] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const reload = useCallback(async () => {
    if (!childId) return;
    setLoading(true); setError("");
    try {
      const { data } = await api.get(`/circulo/children/${childId}`);
      setChild(data);
    } catch (e) { setError(formatApiError(e)); }
    finally { setLoading(false); }
  }, [childId]);
  useEffect(() => { reload(); }, [reload]);
  return { child, loading, error, reload };
}

export function initials(name = "") {
  return name.split(/\s+/).map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}

export const TAG_STYLES = {
  "sueño": "bg-adminbg text-admintext",
  "emoción": "bg-teal-soft text-teal-deep",
  "evento": "bg-warnbg text-warntext",
  "medicación": "bg-errbg text-errtext",
  "logro": "bg-okbg text-oktext",
  "crisis": "bg-errbg text-errtext",
};

export function relativeTime(iso, lang = "es") {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.round(diffMs / 60000);
  if (diffMin < 1) return lang === "es" ? "ahora" : "now";
  if (diffMin < 60) return lang === "es" ? `hace ${diffMin} min` : `${diffMin} min ago`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24) return lang === "es" ? `hace ${diffH} h` : `${diffH} h ago`;
  const diffD = Math.floor(diffH / 24);
  if (diffD < 7) return lang === "es" ? `hace ${diffD} d` : `${diffD} d ago`;
  return d.toLocaleDateString(lang === "es" ? "es-HN" : "en-US");
}
